import { CachingPrefix } from '@enums/caching-prefix.enum';
import { useReactQueryCaching } from '@hooks/use-react-query-caching';
import TestDataParameterService, {
  findAllProps,
} from '@services/test-data.service';
import { NOOP } from '@testsigma/atoms';
import { useQuery } from 'react-query';
import { PreviewService } from '@modules/test-development/services/preview.service';
import { isPreview } from '@utils/common';

type useTestDataFindAllProps = {
  payload: findAllProps;
  enabled: boolean;
  callback: (status, response) => void;
  beforeQuery?: () => void;
  key?;
  applyCache?: boolean;
  isListView?: boolean;
  savePointId?: string;
};

export const useTestDataFindAll = ({
  payload,
  enabled = true,
  key = null,
  callback,
  beforeQuery = NOOP,
  isListView = false,
  applyCache = false,
  savePointId = '',
}: useTestDataFindAllProps) => {
  const { getCachingTime } = useReactQueryCaching(
    CachingPrefix.TEST_DATA_PARAMETER_TESTDATA_CACHING_KEY,
    false,
  );
  const isInPreviewMode = isPreview();
  const apiService = isInPreviewMode
    ? PreviewService.testDataFindAll
    : TestDataParameterService.findAll;
  return useQuery({
    queryKey:
      key ||
      CachingPrefix.TEST_DATA_PARAMETER_TESTDATA_CACHING_KEY +
        JSON.stringify(payload),
    queryFn: () => {
      beforeQuery();
      return apiService(
        payload.query,
        payload.sort,
        payload.size,
        payload.page,
        isListView,
        savePointId,
      );
    },
    onSuccess: (data) => callback(true, data),
    onError: (err) => callback(false, err),
    enabled: enabled,
    staleTime: applyCache ? getCachingTime() : 0,
    cacheTime: applyCache ? getCachingTime() : 0,
  });
};
